module.exports = __webpack_public_path__ + "assets/hush.741c445a.png";